// Lightweight, no-dependency page metadata setter.
// Updates <title>, <meta name="description">, canonical link, and og:title/og:description/og:url
// for public pages that don't already inject their own metadata at runtime.
export function setPageMeta({ title, description, canonicalPath }) {
  if (typeof document === "undefined") return;
  if (title) document.title = title;

  const upsertMeta = (selector, attrName, attrValue, content) => {
    let el = document.head.querySelector(selector);
    if (!el) {
      el = document.createElement("meta");
      el.setAttribute(attrName, attrValue);
      document.head.appendChild(el);
    }
    el.setAttribute("content", content);
  };

  if (description) {
    upsertMeta('meta[name="description"]', "name", "description", description);
    upsertMeta('meta[property="og:description"]', "property", "og:description", description);
    upsertMeta('meta[name="twitter:description"]', "name", "twitter:description", description);
  }
  if (title) {
    upsertMeta('meta[property="og:title"]', "property", "og:title", title);
    upsertMeta('meta[name="twitter:title"]', "name", "twitter:title", title);
  }

  const url = canonicalPath
    ? `https://www.utsahgifting.com${canonicalPath}`
    : (typeof window !== "undefined" ? window.location.href : "");
  if (url) {
    upsertMeta('meta[property="og:url"]', "property", "og:url", url);
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", url);
  }
}
